export default
  "Catalogue public des fiches d'opérations standardisées CEE en vigueur (résidentiel BAR, tertiaire BAT, industrie IND, agriculture AGRI, transport TRA, réseaux RES). Recherche, filtres et conditions d'éligibilité.";
